import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useAccountHomesTabViewModel = ({ accountId }) => {
  const [homes, setHomes] = useState([]);
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();

  const getHomes = () => {
    stateManager.run(async () => {
      const res = await homeService.homes.getAll({
        filters: {
          accountId: { type: "guid", value: accountId },
        },
        sort: "address/addressLine1 asc",
      });
      if (res.status === HTTP_STATUSES.OK) {
        setHomes(res.data);
      }
    });
  };

  return {
    isLoading,
    homes,
    setHomes,
    getHomes,
  };
};
